import { type RadioProps } from "ui/radio/radio.types";

export const useRadio = ({ value, onChange }: Pick<RadioProps, "value" | "onChange">) => {
  const handleChange = () => {
    onChange?.(value);
  };

  return { handleChange };
};
